import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const getCookieData = (cookieName) => {
  const cName = cookieName;
  let cookieData = cookies.get(cName);

  if (cookieData) {
    return cookieData;
  } else {
    return null;
  }
};

export const getOrganizationIdFromToken = () => {
  try {
    const token = getCookieData(process.env.REACT_APP_COOKIE_NAME);
    if (!token) return null;
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload?.organization_id ? String(payload.organization_id) : null;
  } catch {
    return null;
  }
};

export const setCookieData = (cookieName, data, options) => {
  const cName = cookieName;

  cookies.set(cName, data, options);
};
